import React, { useCallback } from 'react';
import classnames from 'clsx';

import { noop } from 'ui-components/default-props/noop';

// @ts-expect-error less import
import style from './percentage-input.module.css';

/**
 * @typedef {import('./percentage-input.d.ts').PercentageInputComponent} PercentageInputComponent
 */

/**
 * @type {PercentageInputComponent}
 */
export const PercentageInput = ({
  value = 0,
  className = '',
  disabled = false,
  onBlur = noop,
  onChange = noop,
  onFocus = noop,
  step = 1,
}) => {
  const classes = classnames(style['percentage-input'], className);

  const handleBlur = useCallback(
    (event) => {
      onBlur(event);
    },
    [onBlur],
  );

  const handleChange = useCallback(
    (event) => {
      const newValue = event.target.value;
      const numericValue = parseFloat(newValue);
      const safeValue = Number.isNaN(numericValue) ? 0 : numericValue;
      onChange(safeValue);
    },
    [onChange],
  );

  const handleFocus = useCallback(
    (event) => {
      event.target.select();
      onFocus(event);
    },
    [onFocus],
  );

  return (
    <div className={classes}>
      <input
        disabled={disabled}
        max='100'
        min='0'
        onBlur={handleBlur}
        onChange={handleChange}
        onFocus={handleFocus}
        step={step}
        type='number'
        value={value}
      />
    </div>
  );
};
